// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3dpfZ","detailsBorder":"styles_detailsBorder__AkLqG"};